import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Ensure this name matches your filename exactly (without the .jsx)
import App from './landingpagenoform'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
